import React from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import { getPerson } from '../ducks/persons.js'

import PersonsForm from './persons_form.jsx'

const PersonsEdit = () => {
  const { id } = useParams()
  
  return (
    <ConnectedForm personId={id} />
  )
}

const ConnectedForm = connect(
  (state, props) => ({
    person: getPerson(state.persons, props.personId),
    errors: state.submissionErrors.persons[props.personId]
  })
)(({ person, errors }) => (
  <PersonsForm person={ person } errors={ errors } />
))
export default PersonsEdit
